"use strict";

var entries = require("./entries.js");

var map = require("./map.js");

var object = require("./object.js");

var pipe = require("./pipe.js");

var reverse1 = require("../.internal/reverse1.js");

const invert = pipe(entries, map(reverse1), object);
module.exports = invert;